import React from 'react';
import ReactDOM from 'react-dom';
import FlatButton from 'material-ui/FlatButton';
import {OverlayTrigger, Tooltip, Overlay, Popover} from "react-bootstrap";
import MdField from 'core/metamodel/mdField';
import GridConfigCondition from 'core/grid/domain/gridConfigCondition';
import GridConfig from 'core/grid/domain/gridConfig';
import StyledSelect from 'core/components/fields/styledSelect';
import MdEntityService from 'core/metamodel/mdEntityService';
import ConditionValueForm, {CONDITIONVALUEFORMCONTEXT} from 'core/grid/component/conditionValueForm';
import GridService from 'core/grid/gridService';
import {lovValue, TExtractFieldFn} from 'core/form/formUtils';
import {fieldStyles} from 'core/form/createForm';
import {ObservableMap, action} from "mobx";
import MdEntity, { LovItem } from 'core/metamodel/mdEntity';
import Grid, {FILTEROPERATOR, SortItem} from "core/grid/domain/grid";
import {observer} from "mobx-react";
import styled from "styled-components";
import {grey400, indigo500} from "material-ui/styles/colors";
import {classNames} from "core/common/utils/domUtils";
import GridConfigColumn from "core/grid/domain/gridConfigColumn";


interface GridHeaderProps {
  grid: Grid;
  gridConfigField: GridConfigColumn;
  field: MdField;
  sortObject: SortItem;
  conditionObject: GridConfigCondition;
  onClickLink: Function;
  refreshGrid: Function;
  gridConfig: GridConfig;
  entities: ObservableMap<MdEntity>;
}

interface GridHeaderState {
  showFilterIcon?: boolean;
  showFilterPopover?: boolean;
  conditionObject?: GridConfigCondition;
}

const TitleP = styled.p`
    color: ${grey400};
    font-size: 18px;
`;

@observer
export default class GridHeader extends React.Component<GridHeaderProps, GridHeaderState>  {



  state: GridHeaderState = {
    showFilterIcon: !!this.props.conditionObject,
    showFilterPopover: false,
    conditionObject: this.props.conditionObject
  };

  filterIconRef: React.ReactInstance;


  componentWillReceiveProps(nextProps) {

    if (!!nextProps.conditionObject !== !!this.props.conditionObject || nextProps.conditionObject !== this.props.conditionObject) {
      this.setState({
        showFilterIcon: !!nextProps.conditionObject,
        conditionObject: nextProps.conditionObject
      });
    }
  }

  filterIconRefHandler = (comp) => {
    this.filterIconRef = comp;
  };

  @action _onClickLink = (evt) => {
    let {field, sortObject} = this.props;
    console.log('_onClickLink %s - %o', field.fieldName, sortObject);

    let newSortObject = {
      field: field,
      desc: (sortObject) ? !sortObject.desc : false
    };

    this.props.onClickLink(newSortObject);
  };

  @action onClickFilter = (evt) => {
    let field = this.props.field;
    console.log('onClickFilter: %o', field);
    let {conditionObject} = this.state;


    if (!conditionObject) {
      conditionObject = new GridConfigCondition(this.props.gridConfig, null);
      conditionObject.field = field;

      if (field.defaultOperator) {
        this.onChangeConditionOperator(conditionObject, field.defaultOperator);
      }
    }

    let entitiesToFetch = [];
    if (field.hasLocalValueSource()) entitiesToFetch.push({entity: field.valueSource, lov: true});

    MdEntityService.fetchEntities(entitiesToFetch)
    .then(entityMap => {
      conditionObject.convertToLov();
      this.setState({showFilterPopover: true, conditionObject});
    });
  };

  @action onChangeConditionOperator(conditionObject: GridConfigCondition, newOperator) {
    newOperator = lovValue(newOperator);
    console.log('onChangeConditionOperator: ', newOperator, conditionObject);

    conditionObject.operator = newOperator;

    if (newOperator) {
      let allOperators = this.props.entities.get('FILTEROPERATOR').lovItems;
      let operatorLov: LovItem & {inputCount?: string|number} = allOperators.find(v => v.value === newOperator);
      conditionObject.values = (operatorLov.inputCount === 'N') ? [] : new Array(parseInt( operatorLov.inputCount as string));
    } else {
      conditionObject.values = [];
    }

    conditionObject.getForm("ConditionValueForm").updateFieldsPropValue(conditionObject, "field0", "field1", "fieldMulti");
    this.setState({conditionObject: conditionObject});
  };


  @action onChangeConditionValues = (conditionObject) => {
    console.log('onChangeConditionValues: condition %O', conditionObject);
    this.setState({conditionObject: conditionObject});
  };


  onMouseOver = (evt) => {
    if (!this.props.conditionObject) this.setState({showFilterIcon: true});
  };
  onMouseOut = (evt) => {
    if (!this.props.conditionObject) this.setState({showFilterIcon: false});
  };
  cancelPopover = (evt) => {
    this.setState({showFilterPopover: false});
  };

  @action submitCondition = (evt) => {
    evt.preventDefault();

    let allOperators = this.props.entities.get('FILTEROPERATOR').lovItems;

    let conditionObject = this.state.conditionObject;
    let form =  conditionObject.getForm("ConditionValueForm");
    if (form.validateForm(conditionObject) &&  GridService.validateCondition(conditionObject, [], 0, allOperators)) {
      this.props.grid.updateGridConditions(conditionObject, this.props.field);
      this.props.refreshGrid();
      this.setState({showFilterPopover: false});
    } else {
      this.setState({conditionObject: conditionObject});
    }
  };

  @action clearCondition = (evt) => {
    this.props.grid.updateGridConditions(null, this.props.field);
    this.props.refreshGrid();
    this.setState({showFilterPopover: false});
  };

  @action onHideHandler = () => {
    this.setState({ showFilterPopover: false });
  };

  overlayTargetHandler = () => ReactDOM.findDOMNode(this.filterIconRef);
  extractFieldFnHandler: TExtractFieldFn<GridConfigCondition> = (dataObject,fieldDef) => dataObject.field;

  render() {

    let {gridConfigField, field, sortObject, entities, gridConfig} = this.props;
    let {conditionObject} = this.state;

    let allOperators = entities.get('FILTEROPERATOR').lovItems;

    let operatorOptions = (conditionObject) ? allOperators.filter(li => conditionObject.field.availableOperators.includes(li.value as FILTEROPERATOR)) : [];

    let tooltipText = field.gridHeaderTooltipActive;

    let desc = (sortObject && sortObject.desc) ? true : false;


    let tooltip = <Tooltip placement="top" id={field.fieldName}>{tooltipText}</Tooltip>;

    let filterPopover = (
      <Overlay
        show={this.state.showFilterPopover}
        onHide={this.onHideHandler}
        rootClose={true}
        target={this.overlayTargetHandler}
        placement="bottom">
        <Popover style={{minWidth: 300, zIndex: 1600}} id={field.fieldName + '_filter'}>
          <TitleP>
            <span><span>Column Filter</span> <span className="fa fa-close" style={{float: 'right', cursor: 'pointer', margin: 6}} onClick={this.cancelPopover} /></span>
          </TitleP>
          {
            (conditionObject) ? (
              <form onSubmit={this.submitCondition}>
                <StyledSelect name="conditionOperator" value={conditionObject.operator} options={operatorOptions} onChange={this.onChangeConditionOperator.bind(this, conditionObject)}
                  {...fieldStyles.small.styledSelect} clearable={false} />
                <div style={{minHeight: 50}}>
                  <ConditionValueForm dataObject={conditionObject} rootObject={gridConfig} entities={entities} context={CONDITIONVALUEFORMCONTEXT.GRIDFILTER}
                                      entity={conditionObject.getEntityRef()} extractFieldFn={this.extractFieldFnHandler} />
                </div>
                <div style={{display: 'flex', justifyContent: 'space-around', marginTop: 10}}>
                  <FlatButton type="submit" label="OK" primary disabled={!conditionObject.operator}/>
                  <FlatButton onClick={this.clearCondition} label="Clear" secondary disabled={!this.props.conditionObject}/>
                </div>
              </form>
            ) : ''
          }

        </Popover>
      </Overlay>
    );

    let filter = (
      <a ref={this.filterIconRefHandler} onClick={this.onClickFilter} onMouseOver={this.onMouseOver} onMouseOut={this.onMouseOut}>
        <span style={{marginLeft:1}} className={classNames('fa', 'fa-filter', {'invisible': !this.state.showFilterIcon})}/>
      </a>

    );


    let anchor = (field.filterable) ? (
      <a onClick={this._onClickLink} onMouseOver={this.onMouseOver} onMouseOut={this.onMouseOut}>
        { (sortObject) ? (
          <span className={classNames('fa', {'fa-long-arrow-up': !desc, 'fa-long-arrow-down': desc})}/> ) : '' }
        {gridConfigField.gridHeaderLabelActive}
      </a>
    ) : (
      <span style={{color: indigo500}}>{gridConfigField.gridHeaderLabelActive}</span>
    );

    let anchorWithTooltip = (
      <OverlayTrigger overlay={tooltip} delayShow={300} delayHide={150}>
        { anchor }
      </OverlayTrigger>
    );

    const showFilter = field.filterable && !(conditionObject != null && conditionObject.superFilter);

    return (

      <span>
        { (tooltipText) ? anchorWithTooltip : anchor}
        { (showFilter) ? filter : ''}
        { (showFilter) ? filterPopover : ''}
      </span>


    );
  }


}



// WEBPACK FOOTER //
// ./src/core/grid/component/gridHeader.tsx